import React from "react";
import classes from "./Shared.module.scss";

const phone = (props) => {
  return (
    <a className={[classes.callLink, classes[props.where]].join(' ')} href="tel: +12512246500">251-224-6500 ext. 4</a>
  );
}
export default phone;